






















































































































































































import { Component, Watch } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import showImage from '@/pantallas/Camaras/Alertas/showImage.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { actionsEvent } from '@/setup';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import VerDetalleModal from './VerDetalleModal.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    WidgetAlerta,
    showImage,
    FormFieldsContainer,
    DatePicker,
    VerDetalleModal,
  },
})
export default class ReportesSerieBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.ReporteSerieActiva;
  mostrarModalVerDetalle: boolean = false;
  loadingService = new LoadingService();
  filtrobusquedagrilla: string = '';
  filtro: any;
  reporteSeleccionado: Number = null;
  serieNumeroSeleccionado: string = null;
  tipoEquipoSeleccionado: string = null;
  serieactivanroSeleccionado: string = null;
  showReporteGenerado: boolean = false;
  tipoeqid: any = '';
  pagina: number = 1;
  length_FLOTA: number = 2;
  length_RUT: number = 2;
  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any = null;
  gridApi: GridApi = null;
  texto_reporte: string = '';
  ordesList: any[] = [];
  equiposlist: any[] = [];
  requermientoslist: any[] = [];
  flotalist: any[] = [];
  racklist: any[] = [];
  bloquelist: any[] = [];
  crm_rutlist: any = [];
  ubicacionlist: any = [];
  estadolist: any = [];
  showModalMostrar: boolean = false;
  usuarioID: any = '';
  hashpaginacion: string = '';
  rowcount: number = 0;
  total_registros: number = 0;
  cant_regs_pag: number = 25;

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { '': '' },
      'ReportesSerieEstadia/get_grilla_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.equiposlist = data.data.EQUIPOS;
          self.requermientoslist = data.data.REQUERIMIENTOS;
          self.flotalist = data.data.FLOTA;
          self.racklist = data.data.RACK;
          self.bloquelist = data.data.BLOQUE;
          self.crm_rutlist = data.data.CRM_RUT;
          self.ubicacionlist = data.data.UBICACION;
          self.estadolist = data.data.ESTADO;
          self.length_FLOTA = data.data.FLOTA.length;
          self.length_RUT = data.data.CRM_RUT.length;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  @Watch('formFields.fechaInicio.value')
  validateDataStart() {
    if (this.formFields.fechaInicio.value > this.formFields.fechaFin.value) {
      this.formFields.fechaFin.value = this.formFields.fechaInicio.value;
    }
  }

  @Watch('formFields.fechaFin.value')
  validateDataEnd() {
    if (this.formFields.fechaFin.value < this.formFields.fechaInicio.value) {
      this.formFields.fechaInicio.value = this.formFields.fechaFin.value;
    }
  }

  async datos_requerimientos() {
    let body: any = this.filtros2body();
    if (body.requerimiento == '') {
      this.getEquipos();
      this.formFields.flota.value = undefined;
      this.formFields.rut.value = undefined;
    } else {
      this.loadingService.showLoading();
      return fetchReportesSerie(
        { requerimiento: body.requerimiento },
        'ReportesSerie/change_requerimiento'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.formFields.flota.value = data.data.FLOTA[0].asigcrm_flota;
            this.formFields.flota.value = data.data.FLOTA[0].__nom_flota;
            this.formFields.rut.value = data.data.CRM_RUT[0].asigcrm_rutcli;
            this.length_FLOTA = data.data.FLOTA.length;
            this.length_RUT = data.data.CRM_RUT.length;
          } else {
            return;
          }
        })
        .catch((error: any) => {
          this.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
    }
  }
  async handleGridReady(event: GridReadyEvent) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    this.gridApi = event.api;
    this.gridApi.setDomLayout('autoHeight');
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    let self = this;
    this.serverSide = {
      getRows(event: any): void {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.pagina = Math.ceil(
          event.request.startRow / self.cant_regs_pag + 1
        );
        let body: any = self.filtros2body();
        body.pagina = self.pagina;

        fetchReportesSerie(
          {
            estado: body.estado,
            requerimiento: body.requerimiento,
            serienumero: body.serienumero,
            flota: body.flota,
            rut: body.rut,
            TipoEquipo: body.TipoEquipo,
            rack: body.rack,
            Bloque: body.Bloque,
            pagina: body.pagina,
            ubicacion: body.ubicacion,
            dateStart: body.dateStart,
            dateEnd: body.dateEnd,
          },
          'ReportesSerieEstadia/get_filtered_rs'
        )
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '1') {
              if (body.ubicacion == '') {
                self.$snotify.error('El campo ubicación es requerido', {
                  timeout: 3000,
                });
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else if (body.dateStart == '') {
                self.$snotify.error('El campo Fecha Inicio es requerido', {
                  timeout: 3000,
                });
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else if (body.dateEnd == '') {
                self.$snotify.error('El campo Fecha Fin es requerido', {
                  timeout: 3000,
                });
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else if (response.data.data.length === 0) {
                self.$snotify.error('Sin registros', { timeout: 3000 });
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else {
                event.successCallback(
                  response.data.data.LISTA,
                  Number(response.data.cant_regs_pag.TOTAL_REGISTROS)
                );
                self.gridApi.hideOverlay();
                self.autoSizeAll(true);
              }
            } else {
              event.successCallback([{}], 0);
              self.$snotify.error(response.data.MENSAJE_RESPUESTA, {
                timeout: 3000,
              });
            }
          })
          .catch((error: any) => {
            event.successCallback([{}], 0);
            self.$snotify.error('Sin Registros', {
              timeout: 3000,
            });
          })
          .finally(() => {
            self.gridApi.setDomLayout('autoHeight');
          });
      },
    };
    this.getEquipos();
    this.clearFilters();
  }
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Equipo Serie',
        field: 'Equipo Serie',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },
      {
        headerName: 'Tipo de Equipo',
        field: 'Tipo de Equipo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'IMEI',
        field: 'IMEI',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },

      {
        headerName: 'Compra Número',
        field: 'Compra Numero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Fecha de Compra',
        field: 'Fecha de Compra',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        valueFormatter: function(params) {
          if (params.value) {
            return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
          }
        },
      },
      {
        headerName: 'Número de Activación',
        field: 'Número de Activación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'EPC',
        field: 'EPC',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Fecha Preparación',
        field: 'Fecha Preparación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        valueFormatter: function(params) {
          if (params.value) {
            return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
          }
        },
      },
      {
        headerName: 'Requerimiento Preparación',
        field: 'Requerimiento Preparación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'CRM Flota Preparación',
        field: 'CRM Flota Preparación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Cliente Preparación',
        field: 'Cliente Preparación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },
      {
        headerName: 'Modalidad',
        field: 'Modalidad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Plataforma',
        field: 'Plataforma',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Id de Equipo en Plataforma',
        field: 'Id de Equipo en Plataforma',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Estado en Plataforma',
        field: 'enplat',
        cellStyle: { textAlign: 'center' },
        resizable: true,
        width: 140,
        cellRenderer: params => {
          if (!params.value) return '';
          if (params.data.enplat == 'S') {
            var html = '<input type="checkbox" checked disabled>';
            return html;
          } else {
            return '<input type="checkbox" disabled>';
          }
        },
      },
      {
        headerName: 'Fecha de Ingreso en Plataforma',
        field: 'Fecha de Ingreso en Plataforma',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        valueFormatter: function(params) {
          if (params.value) {
            return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
          }
        },
      },
      {
        headerName: 'SIM Serie Número',
        field: 'SIM Serie Número',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Estado de la SIM',
        field: 'Estado de la SIM',
        cellStyle: { textAlign: 'center' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Prefijo',
        field: 'Prefijo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Número del Móvil',
        field: 'Número del Movil',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Telco',
        field: 'Telco',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Plan',
        field: 'Plan',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'APN',
        field: 'APN',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Fecha de Instalación',
        field: 'Fecha de Instalación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        valueFormatter: function(params) {
          if (params.value) {
            return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
          }
        },
      },
      {
        headerName: 'Patente',
        field: 'Patente',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Cliente Instalación',
        field: 'Cliente Instalación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Flota Instalación',
        field: 'Flota Instalación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Fecha Desinstalación',
        field: 'Fecha Desinstalación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        valueFormatter: function(params) {
          if (params.value) {
            return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
          }
        },
      },
      {
        headerName: 'Observación de Desinstalación',
        field: 'Observacion de Desinstalación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Ubicación',
        field: 'Ubicación Actual',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Fecha de Ingreso',
        field: 'Fecha de Ingerso',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        valueFormatter: function(params) {
          if (params.value) {
            return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
          }
        },
      },
      {
        headerName: 'Fecha de Egreso',
        field: 'Fecha de Egreso',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        valueFormatter: function(params) {
          if (params.value) {
            return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
          }
        },
      },
      {
        headerName: 'Tipo de Operación',
        field: 'Tipo de Operación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },

      {
        headerName: 'Número de Operación',
        field: 'Número de Operación',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Días de Estadía',
        field: 'Días de Estadía',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
    ],

    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 50,
    cacheBlockSize: this.cant_regs_pag,
    paginationAutoPageSize: false,
    rowModelType: 'serverSide',
    serverSideDatasource: this.serverSide,
    onGridReady: this.handleGridReady,
    overlayNoRowsTemplate: 'No hay filas para mostrar',
  };

  handleCierreModalVerDetalle() {
    this.mostrarModalVerDetalle = false;
  }

  formFields: FormFieldDefMap = {
    ubicacion: {
      label: 'Ubicación',
      id: 'tipoubicaid',
      value: 'tipoubicaname',
    },
    requerimiento: {
      label: 'Requerimiento',
      id: 'asigrequerimiento',
      value: 'asigrequerimiento',
    },
    fechaInicio: {
      label: 'Fecha Inicio',
      id: 'fechaInicio',
      value: moment().subtract(1, 'month'),
    },
    fechaFin: {
      label: 'Fecha Fin',
      id: 'fechaFin',
      value: moment(),
    },
    flota: {
      label: 'Flota Preparación',
      id: '__nom_flota',
      value: 'asigcrm_flota',
    },
    rut: {
      label: 'Cliente Preparación',
      id: 'asigcrm_rutcli',
      value: 'asigcrm_rutcli',
    },
    TipoEquipo: {
      label: 'Tipo Equipo',
      id: 'tipoeqid',
      value: 'tipoeqname',
    },
    rack: {
      label: 'Rack',
      id: 'moviserierack',
      value: 'moviserierack',
    },
    Bloque: {
      label: 'Bloque',
      id: 'moviseriebloque',
      value: 'moviseriebloque',
    },
    estado: {
      label: 'Estado SIM',
      id: 'configvalor',
      value: 'configid',
    },
    equiposerie: {
      label: 'Equipo Serie',
      id: '',
      value: '',
    },
  };

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }
  handleBuscarClick() {
    this.filtroRequerimiento(true);
  }
  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }
  get fechaMinimaInicio() {
    let fechaIni = this.formFields.fechaInicio.value;
    return fechaIni as moment.Moment;
  }
  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }
  get fechaMaximaInicio() {
    //let fechaMax = this.formFields.fechaInicio.value;

    return moment(this.fechaMaxima) as moment.Moment;
    //return fechaMax as moment.Moment;
  }
  async clearFilters() {
    Object.keys(this.formFields).forEach(
      key => (this.formFields[key].value = '')
    );
    this.formFields.fechaInicio.value = moment().subtract(1, 'month');
    this.formFields.fechaFin.value = moment();
    this.length_FLOTA = 2;
    this.length_RUT = 2;
    this.filtroRequerimiento(true);
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };

  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: true,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionExportar,
    this.accionVerDetalle,
  ];

  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handleVerDetalleClick);
  }

  handleVerDetalleClick(params: ICellRendererParams) {
    this.reporteSeleccionado = params.data['asignumero'];
    this.serieNumeroSeleccionado = params.data['Equipo Serie'];
    this.tipoEquipoSeleccionado = params.data['tipoeqid'];
    this.serieactivanroSeleccionado = params.data['Número de Activación'];
    this.mostrarModalVerDetalle = true;
  }
  filtroRequerimiento(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }
  async fetchRequermientosWidgets() {
    this.loadingService.showLoading();
  }
  filtros2body() {
    let body: any = {};
    body.requerimiento = this.formFields.requerimiento.value
      ? this.formFields.requerimiento.value
      : '';
    body.flota = this.formFields.flota.value ? this.formFields.flota.value : '';
    body.rut = this.formFields.rut.value ? this.formFields.rut.value : '';
    body.TipoEquipo = this.formFields.TipoEquipo.value
      ? this.formFields.TipoEquipo.value
      : '';
    body.rack = this.formFields.rack.value ? this.formFields.rack.value : '';
    body.Bloque = this.formFields.Bloque.value
      ? this.formFields.Bloque.value
      : '';
    body.estado = this.formFields.estado.value
      ? this.formFields.estado.value
      : '';
    body.ubicacion = this.formFields.ubicacion.value
      ? this.formFields.ubicacion.value
      : '';
    body.dateStart = this.formFields.fechaInicio.value
      ? this.formFields.fechaInicio.value
      : '';
    body.dateEnd = this.formFields.fechaFin.value
      ? this.formFields.fechaFin.value
      : '';
    body.serienumero = this.formFields.equiposerie.value
      ? this.formFields.equiposerie.value
      : '';
    return body;
  }
  async btn_exportar() {
    let body: any = this.filtros2body();
    (body.extension = 'csv'),
      this.loadingService.showLoading(undefined, 'btn_exportar');

    const self = this;
    return fetchReportesSerie(
      {
        body: body,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        user_id: JSON.parse(localStorage.getItem('user')).id,
        tipo_alerta: 'CONECTA_REPORTES_SERIE',
      },
      'ReportesSerieEstadia/exportar'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '2') {
          return self.$snotify.error(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
        this.showReporteGenerado = true;

        this.texto_reporte = data.data.MENSAJE_RESPUESTA;
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('btn_exportar');
        return null;
      });
  }
  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }
}
